import {
  LIST_MCU_PROJECT_PATIENT_BATCH_REQUEST,
  LIST_MCU_PROJECT_PATIENT_BATCH_SUCCESS,
  LIST_MCU_PROJECT_PATIENT_BATCH_FAIL,
  LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_FAIL,
  LIST_MCU_PROJECT_PERIOD_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_PERIOD_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_PERIOD_SUMMARY_FAIL,
  CREATE_MCU_PROJECT_PATIENT_BATCH_REQUEST,
  CREATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS,
  CREATE_MCU_PROJECT_PATIENT_BATCH_FAIL,
  DETAIL_MCU_PROJECT_PATIENT_BATCH_REQUEST,
  DETAIL_MCU_PROJECT_PATIENT_BATCH_SUCCESS,
  DETAIL_MCU_PROJECT_PATIENT_BATCH_FAIL,
  UPDATE_MCU_PROJECT_PATIENT_BATCH_REQUEST,
  UPDATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS,
  UPDATE_MCU_PROJECT_PATIENT_BATCH_FAIL,
  DELETE_MCU_PROJECT_PATIENT_BATCH_REQUEST,
  DELETE_MCU_PROJECT_PATIENT_BATCH_SUCCESS,
  DELETE_MCU_PROJECT_PATIENT_BATCH_FAIL,
  RESET_MCU_PROJECT_PATIENT_BATCH
} from '../../constants/mcu-project-patient-batch'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  loadingPeriodSummary: false,
  mcuProjectPatientBatchs: [],
  mcuProjectPeriodSummaries: [],
  mcuProjectPatientBatch: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_PATIENT_BATCH_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_PATIENT_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectPatientBatchs: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_PATIENT_BATCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectPatientBatchs: action?.dummy
      }
    case LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectPatientBatchs: action.payload
      }
    case LIST_MCU_PROJECT_PATIENT_BATCH_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_MCU_PROJECT_PERIOD_SUMMARY_REQUEST:
      return { ...state, loadingPeriodSummary: true }
    case LIST_MCU_PROJECT_PERIOD_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingPeriodSummary: false,
        mcuProjectPeriodSummaries: action.payload
      }
    case LIST_MCU_PROJECT_PERIOD_SUMMARY_FAIL:
      return {
        ...state,
        loadingPeriodSummary: false,
        error: action.payload,
        mcuProjectPeriodSummaries: []
      }
    case CREATE_MCU_PROJECT_PATIENT_BATCH_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_MCU_PROJECT_PATIENT_BATCH_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_MCU_PROJECT_PATIENT_BATCH_REQUEST:
      return { ...state, loadingCreate: true, mcuProjectPatientBatch: {} }
    case DETAIL_MCU_PROJECT_PATIENT_BATCH_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        mcuProjectPatientBatch: action.payload
      }
    case DETAIL_MCU_PROJECT_PATIENT_BATCH_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case UPDATE_MCU_PROJECT_PATIENT_BATCH_REQUEST:
      return { ...state, loadingCreate: true }
    case UPDATE_MCU_PROJECT_PATIENT_BATCH_SUCCESS:
      return { ...state, loadingCreate: false }
    case UPDATE_MCU_PROJECT_PATIENT_BATCH_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_MCU_PROJECT_PATIENT_BATCH_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_MCU_PROJECT_PATIENT_BATCH_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_MCU_PROJECT_PATIENT_BATCH_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_MCU_PROJECT_PATIENT_BATCH:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default mcuProjectReducer
